import { render, staticRenderFns } from "./ProjectAccountSharing.vue?vue&type=template&id=7475c0dc&scoped=true&"
import script from "./ProjectAccountSharing.vue?vue&type=script&lang=js&"
export * from "./ProjectAccountSharing.vue?vue&type=script&lang=js&"
import style0 from "./ProjectAccountSharing.vue?vue&type=style&index=0&id=7475c0dc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7475c0dc",
  null
  
)

export default component.exports